// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"64":"a28d8ffb","79":"c609aa5a","511":"4e68970d","606":"8f4e5695","746":"8b5feb85","886":"5896d000","929":"d8679302","992":"2807dd25"}[chunkId] + ".chunk.js";
};